<template>
  <div class="about">
    <!--img alt="Vue logo" src="../assets/logo.png"-->
    <AboutWorld msg="（株）HIRO ICT研究所について（工事中）"/>

  </div>
</template>

<script>
// @ is an alias to /src
import AboutWorld from '@/components/AboutWorld.vue'

export default {
  name: 'About',
  components: {
    AboutWorld
  }
}
</script>
